
type CookieOptions = {
  expiresInDays?: number;
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
  path?: string;
  expirationDate?: string
};
export const COOKIE_CHANGE_EVENT = 'uc:cookie-change';

type CookieChangeDetail = {
  name: string;
  value: string | null;
};

const dispatchCookieChange = ({ name, value }: CookieChangeDetail) => {
  window.dispatchEvent(
    new CustomEvent<CookieChangeDetail>(COOKIE_CHANGE_EVENT, {
      detail: { name, value },
    })
  );
};

export const setCookie = (
  name: string,
  value: string,
  options: CookieOptions = {}
) => {
  let cookieString = `${name}=${encodeURIComponent(value)}`;

  if (options.expiresInDays) {
    const expires = new Date();
    expires.setTime(
      expires.getTime() + options.expiresInDays * 24 * 60 * 60 * 1000
    );
    cookieString += `;expires=${expires.toUTCString()}`;
  }
  else if(options.expirationDate){
    cookieString += `;expires=${options.expirationDate}`
  }

  cookieString += `;path=${options.path || '/'}`;
  cookieString += `;domain=.paymob.com`;

  if (options.secure) {
    cookieString += ';secure';
  }

  if (options.sameSite) {
    cookieString += `;SameSite=${options.sameSite}`;
  }

  document.cookie = cookieString;
  dispatchCookieChange({ name, value });
};

export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? decodeURIComponent(match[2]) : null;
};

export const removeCookie = (name: string) => {
  let cookieString = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC`;
  cookieString += `;path=/`;
  cookieString += `;domain=.paymob.com`;

  document.cookie = cookieString;
  dispatchCookieChange({ name, value: null });
};
